<template>
  <Form class="base-properties-form" ref="record" :model="record">
    <Row :gutter="20">
      <i-col :span="12">
        <FormItem :label="$t('rules.omitIfEmpty')" prop="omitIfEmpty">
          <Tooltip max-width="250px" class="field-help" transfer placement="top" :content="$t('rules.omitIfEmptyDesc')">
            <Icon type="md-help-circle"> </Icon>
          </Tooltip>
          <div class="radio-control">
            <span class="radio-item">
              <input
                v-model="record.omitIfEmpty"
                id="true-omit-radio"
                type="radio"
                :value="true"
                :disabled="isDetail"
              />
              <label for="true-omit-radio">True</label>
            </span>
            <span class="radio-item">
              <input
                v-model="record.omitIfEmpty"
                id="false-omit-radio"
                type="radio"
                :value="false"
                :disabled="isDetail"
              />
              <label for="false-omit-radio">False</label>
            </span>
          </div>
        </FormItem>
      </i-col>
      <i-col :span="12">
        <FormItem :label="$t('rules.sendSingle')" prop="sendSingle">
          <Tooltip max-width="250px" class="field-help" transfer placement="top" :content="$t('rules.sendSingleDesc')">
            <Icon type="md-help-circle"> </Icon>
          </Tooltip>
          <div class="radio-control">
            <span class="radio-item">
              <input :disabled="isDetail" id="true-send-radio" type="radio" v-model="record.sendSingle" :value="true" />
              <label for="true-send-radio">True</label>
            </span>
            <span class="radio-item">
              <input
                :disabled="isDetail"
                id="false-send-radio"
                type="radio"
                v-model="record.sendSingle"
                :value="false"
              />
              <label for="false-send-radio">False</label>
            </span>
          </div>
        </FormItem>
      </i-col>
      <!-- format -->
      <i-col :span="12">
        <FormItem :label="$t('streams.format')" prop="format">
          <FormatsSelector v-model="record.format" @onChange="changeFormat" @clear="changeFormat" />
        </FormItem>
      </i-col>

      <!-- format: protobuf | custom -->
      <i-col v-if="record.format === 'protobuf' || record.format === 'custom'" :span="12">
        <FormItem :label="$t('streams.schemaName')" prop="format">
          <SchemasSelector
            v-model="record.schemaName"
            :type="record.format"
            @onChange="changeSchemaName"
            @clear="changeSchemaName"
          />
        </FormItem>
      </i-col>
      <i-col v-if="record.format === 'protobuf' || record.format === 'custom'" :span="12">
        <FormItem :label="$t('streams.schemaMessage')" prop="format">
          <i-input v-model="record.schemaMessage" size="large"></i-input>
        </FormItem>
      </i-col>
      <!-- format: delimited -->
      <i-col v-if="record.format === 'delimited'" span="12">
        <FormItem :label="$t('streams.delimited')" prop="delimited">
          <i-input v-model="record.delimited" size="large"></i-input>
        </FormItem>
      </i-col>
      <!-- dataTemplate -->
      <i-col :span="24">
        <FormItem :label="$t('rules.dataTemplate')" prop="dataTemplate">
          <Tooltip
            max-width="250px"
            class="field-help"
            transfer
            placement="top"
            :content="$t('rules.dataTemplateDesc')"
          >
            <Icon type="md-help-circle"> </Icon>
          </Tooltip>
          <i-input v-model="record.dataTemplate" type="textarea" size="large" :rows="3" :disabled="isDetail"></i-input>
        </FormItem>
      </i-col>
      <Divider>
        <a href="javascript:;" @click="showAdvanced = !showAdvanced">
          <Icon v-if="showAdvanced" type="ios-arrow-up" />
          <Icon v-else type="ios-arrow-down" />
          {{ $t('common.advanced') }}
        </a>
      </Divider>
      <!--  showAdvanced -->
      <template v-if="showAdvanced">
        <i-col v-show="isCanConnection" :span="12">
          <FormItem :label="$t('configuration.connectionSelector')" prop="connectionSelector">
            <ConnectionSelector v-model="record.connectionSelector" :type="type" @onChange="changeConnectionSelector" />
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.concurrency')" prop="concurrency">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.sinkConcurrencyDesc')"
            >
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <i-input
              v-model.number="record.concurrency"
              type="number"
              size="large"
              :disabled="isDetail"
              placeholder="1"
            ></i-input>
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.bufferLength')" prop="bufferLength">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.sinkBufferLengthDesc')"
            >
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <i-input
              v-model.number="record.bufferLength"
              type="number"
              size="large"
              :disabled="isDetail"
              placeholder="1024"
            ></i-input>
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.enableCache')" prop="enableCache">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.enableCacheDesc')"
            >
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <div class="radio-control">
              <span class="radio-item">
                <input
                  id="true-enable-cache-radio"
                  type="radio"
                  v-model="record.enableCache"
                  :value="true"
                  :disabled="isDetail"
                />
                <label for="true-enable-cache-radio">True</label>
              </span>
              <span class="radio-item">
                <input
                  :disabled="isDetail"
                  id="false-enable-cache-radio"
                  type="radio"
                  v-model="record.enableCache"
                  :value="false"
                />
                <label for="false-enable-cache-radio">False</label>
              </span>
            </div>
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.cleanCacheAtStop')" prop="cleanCacheAtStop">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.cleanCacheAtStopDesc')"
            >
              <Icon type="md-help-circle"></Icon>
            </Tooltip>
            <div class="radio-control">
              <span class="radio-item">
                <input
                  id="true-clean-cache-radio"
                  type="radio"
                  v-model="record.cleanCacheAtStop"
                  :value="true"
                  :disabled="isDetail"
                />
                <label for="true-clean-cache-radio">True</label>
              </span>
              <span class="radio-item">
                <input
                  :disabled="isDetail"
                  id="false-clean-cache-radio"
                  type="radio"
                  v-model="record.cleanCacheAtStop"
                  :value="false"
                />
                <label for="false-clean-cache-radio">False</label>
              </span>
            </div>
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.memoryCacheThreshold')" prop="memoryCacheThreshold">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.memoryCacheThresholdDesc')"
            >
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <i-input
              v-model.number="record.memoryCacheThreshold"
              type="number"
              size="large"
              :disabled="isDetail"
              placeholder="1024"
            ></i-input>
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.maxDiskCache')" prop="maxDiskCache">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.maxDiskCacheDesc')"
            >
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <i-input
              v-model.number="record.maxDiskCache"
              type="number"
              size="large"
              :disabled="isDetail"
              placeholder="1024000"
            ></i-input>
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.bufferPageSize')" prop="bufferPageSize">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.bufferPageSizeDesc')"
            >
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <i-input
              v-model.number="record.bufferPageSize"
              type="number"
              size="large"
              :disabled="isDetail"
              placeholder="256"
            ></i-input>
          </FormItem>
        </i-col>
        <i-col :span="12">
          <FormItem :label="$t('rules.resendInterval')" prop="resendInterval">
            <Tooltip
              max-width="250px"
              class="field-help"
              transfer
              placement="top"
              :content="$t('rules.resendIntervalDesc')"
            >
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <i-input
              v-model.number="record.resendInterval"
              type="number"
              size="large"
              :disabled="isDetail"
              placeholder="0"
            ></i-input>
          </FormItem>
        </i-col>

        <i-col :span="12">
          <FormItem :label="$t('rules.runAsync')" prop="runAsync">
            <Tooltip max-width="250px" class="field-help" transfer placement="top" :content="$t('rules.runAsyncDesc')">
              <Icon type="md-help-circle"> </Icon>
            </Tooltip>
            <div class="radio-control">
              <span class="radio-item">
                <input :disabled="isDetail" id="true-run-radio" type="radio" v-model="record.runAsync" :value="true" />
                <label for="true-run-radio">True</label>
              </span>
              <span class="radio-item">
                <input
                  :disabled="isDetail"
                  id="false-run-radio"
                  type="radio"
                  v-model="record.runAsync"
                  :value="false"
                />
                <label for="false-run-radio">False</label>
              </span>
            </div>
          </FormItem>
        </i-col>
      </template>
    </Row>
  </Form>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { cloneDeep } from 'lodash'
import schema from '@/mixins/schema'
import nodeID from '@/mixins/nodeID'
import ConnectionSelector from '@/components/ConnectionSelector.vue'
import FormatsSelector from '@/components/FormatsSelector.vue'
import SchemasSelector from '@/components/SchemasSelector.vue'

export default {
  name: 'BasePropertiesForm',

  mixins: [nodeID, schema],

  components: {
    ConnectionSelector,
    FormatsSelector,
    SchemasSelector,
  },

  props: {
    type: {
      type: String,
      default: '',
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showAdvanced: false,
      record: {},
      schemaNameList: [],
    }
  },

  computed: {
    // Only `edgex` and `mqtt` support connectionSelector
    isCanConnection() {
      return ['mqtt', 'edgex'].includes(this.type)
    },
  },

  watch: {
    form: {
      immediate: true,
      handler(val) {
        const keys = Object.keys(val)
        if (!keys.length) {
          this.setDefaultValues()
        } else {
          this.record = cloneDeep(val)
        }
      },
      deep: true,
    },
  },

  methods: {
    // set record form default data
    setDefaultValues() {
      this.record = {
        runAsync: false,
        omitIfEmpty: false,
        sendSingle: true,
        dataTemplate: '',
        bufferLength: 1024,
        enableCache: false,
        format: 'json',
        schemaName: '',
        schemaMessage: '',
        delimited: '',
      }
    },
    getFormData() {
      return new Promise((resolve, reject) => {
        this.$refs.record.validate((valid) => {
          if (!valid) {
            reject(new Error(this.$t('common.invalidateForm')))
          }
          resolve(this.record)
        })
      })
    },
    resetFields() {
      this.record = {}
    },
    changeConnectionSelector(val) {
      this.$emit('changeConnectionSelector', val)
    },

    changeFormat(val) {
      this.record.schemaName = ''
      this.changeSchemaName()
      this.record.delimited = val === 'delimited' ? ',' : ''
    },
    changeSchemaName() {
      this.record.schemaMessage = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.format-content {
  width: 100%;
}
</style>
